import * as Yup from 'yup';
import { EMAIL_REGEX, isValidMobileNumber, extractNationalNumber } from 'utils';

export interface IResetPasswordSchema {
  email: string;
  mobilePhoneNumber: string;
}

const resetPasswordSchema = t =>
  Yup.object({
    email: Yup.string()
      .matches(EMAIL_REGEX, {
        message: t('resetPassword.errors.invalidEmail'),
        excludeEmptyString: true,
      })
      .test('email-or-phone-required', t('resetPassword.errors.emailRequired'), function (value) {
        const { mobilePhoneNumber } = this.parent;
        const nationalNumber = extractNationalNumber(mobilePhoneNumber);
        const hasPhoneAttempt = nationalNumber && nationalNumber.trim() !== '';
        const hasEmail = value?.trim();

        return !!(hasEmail || hasPhoneAttempt);
      }),
    mobilePhoneNumber: Yup.string()
      .trim()
      .test('phone-or-email-required', t('resetPassword.errors.phoneNumberRequired'), function (value) {
        const { email } = this.parent;
        const nationalNumber = extractNationalNumber(value);
        const hasPhoneAttempt = nationalNumber && nationalNumber.trim() !== '';
        const hasEmail = email?.trim();

        return !!(hasPhoneAttempt || hasEmail);
      })
      .test('mobilePhoneNumber-valid', t('resetPassword.errors.invalidPhoneNumber'), function (value) {
        const nationalNumber = extractNationalNumber(value);
        if (!nationalNumber || nationalNumber.trim() === '') {
          return true;
        }
        return isValidMobileNumber(value);
      }),
  }) as Yup.ObjectSchema<IResetPasswordSchema>;

export default resetPasswordSchema;
